import { render, staticRenderFns } from "./titleName.vue?vue&type=template&id=7892b1c4&scoped=true"
import script from "./titleName.vue?vue&type=script&lang=js"
export * from "./titleName.vue?vue&type=script&lang=js"
import style0 from "./titleName.vue?vue&type=style&index=0&id=7892b1c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892b1c4",
  null
  
)

export default component.exports